import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { getRooftopFeaturesApi } from 'api/features';
import type { GetRooftopFeaturesResponseDTO } from 'declarations/dto/features';
import { RequestQueryKeysE, RequestStaleTimeE } from 'declarations/enums/react-query';
import type { ApiErrorI } from 'declarations/interfaces/errors';

export const useFetchRooftopFeatures = (
  rooftopId: string
): UseQueryResult<GetRooftopFeaturesResponseDTO, ApiErrorI> =>
  useQuery<GetRooftopFeaturesResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.GetRooftopFeatures, rooftopId],
    (): Promise<GetRooftopFeaturesResponseDTO> => getRooftopFeaturesApi(rooftopId),
    { staleTime: RequestStaleTimeE.TicketsCountByRoofTop }
  );
